interface IProps {
  isNoBorder?: boolean;
}

const Svg = ({ isNoBorder = false }: IProps) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 64 64"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.9295 2.1456L38.9607 21.1132C39.2906 22.1509 40.2543 22.8557 41.3431 22.8557H60.9509C62.3961 22.8557 63.0054 24.6985 61.845 25.56L45.9082 37.3917C45.0509 38.0282 44.6924 39.139 45.016 40.1566L51.0857 59.2452C51.5269 60.6329 49.9312 61.7722 48.7621 60.9042L32.9902 49.195C32.1054 48.538 30.8947 48.538 30.0098 49.195L14.2379 60.9042C13.0688 61.7722 11.4731 60.6329 11.9143 59.2452L17.984 40.1566C18.3076 39.139 17.9491 38.0282 17.0918 37.3917L1.15496 25.56C-0.00543737 24.6985 0.603872 22.8557 2.04909 22.8557H21.6569C22.7457 22.8557 23.7094 22.1509 24.0393 21.1132L30.0705 2.14561C30.5138 0.751653 32.4862 0.751654 32.9295 2.1456Z"
        fill="currentColor"
        stroke={isNoBorder ? "none" : "black"}
      />
    </svg>
  );
};

export default Svg;
